// src/components/Footer/Footer.tsx
import { Box, Text, Group, Anchor } from "@mantine/core";

export function Footer() {
  return (
    <Box
      component="footer"
      py="md"
      px="lg"
      bg="var(--mantine-color-dark-8)"
      c="var(--mantine-color-gray-4)"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "auto", // IMPORTANT: Pushes the footer to the bottom
        width: "100%",
        boxShadow: "0 -2px 5px rgba(0,0,0,0.1)",
      }}
    >
      <style
        dangerouslySetInnerHTML={{
          __html: `
            .grecaptcha-badge {
              visibility: hidden !important;
              opacity: 0 !important;
              transition: opacity 0.1s ease !important;
            }
          `,
        }}
      />
      <Group justify="center" gap="md" mb="xs">
        <Anchor
          href="https://www.earlybirdrsvp.com"
          c="inherit"
          size="sm"
          target="_blank"
          rel="noopener noreferrer"
        >
          Web Site
        </Anchor>
        <Anchor
          href="https://www.earlybirdrsvp.com/support"
          c="inherit"
          size="sm"
          target="_blank"
          rel="noopener noreferrer"
        >
          Support
        </Anchor>
        <Anchor
          href="https://www.earlybirdrsvp.com/legal"
          c="inherit"
          size="sm"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy and Terms of Service
        </Anchor>
      </Group>

      <Text size="sm" mt="0" mb="xs">
        © {new Date().getFullYear()} Early Bird RSVP. All rights reserved.
      </Text>

      <Text size="sm" mt="0" mb="md">
        This site is protected by reCAPTCHA.
      </Text>
    </Box>
  );
}
